import { Component, OnInit } from "@angular/core";

import { AuthService } from "../../../services/auth.service";
import { CompanyService } from "../../../services/company.service";
import { CustomerTypeService } from "../../../services/customer-type.service";
import { LocationService } from "../../../services/location.service";
import { Router } from "@angular/router";

import { saveAs as importedSaveAs } from "file-saver";

import * as moment from "moment";
import { Page } from "../../../models/paging/page";
import { FillBatchReportService } from "../../../services/fill-batch-report.service";
import { ModalService } from "../../../services/modal.service";
import { CheckUserType } from "../../../models/checkUserType";
import { ColumnService } from "../../../services/ColumnService";

@Component({
  selector: "app-fill-batch-report",
  templateUrl: "./fill-batch-report.component.html",
  styleUrls: ["./fill-batch-report.component.css"],
})
export class FillBatchReportComponent implements OnInit {
  modalService: ModalService;
  role = new CheckUserType();
  client;

  filter: any = {
    start_Date: moment().toDate(),
    end_Date: moment().toDate(),
    batch_Num: "",
    quick_Search: "",
  };

  availableOptions: string[] = [
    "Fill Date",
    "Batch #",
    "Fill Pressure",
    "User",
    "# of Cylinders",
    "# of Rejects",
    "Expiry Date",
  ];

  selectedOptions: string[] = [
    "Fill Date",
    "Batch #",
    "Fill Pressure",
    "User",
    "# of Cylinders",
    "# of Rejects",
    "Expiry Date",
  ];

  viewtype: 0;
  page = new Page();
  rows = Array<any>();
  init: boolean;

  showHistory: boolean = false;
  cylinder_Id: string;
  cylinder_Serial_No: string;

  constructor(
    authService: AuthService,
    public fillBatchReportService: FillBatchReportService,
    public router: Router,
    modalService: ModalService,
    private columnService: ColumnService
  ) {
    this.client = authService.currentUser.value;
    this.role.initClient(this.client.role);
    this.modalService = modalService;

    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = "desc";
    this.page.sortBy = "";

    this.loadTable(this.page);
  }

  ngOnInit() {
    this.getcolumns();
    this.loadTable(this.page);
    this.init = true;
  }

  loadFillBatchCyl(row: any) {
    const url =
    this.router.serializeUrl(this.router.createUrlTree(["reports/fill_batch_cyl"], {
      queryParams: {
        fill_Batch_Id: row.fill_Batch_ID,
        reject: false,
      },
    }
  )
  );
  window.open(url,'_blank');
  }

  loadFillBatchCylReject(row: any) {
    const url = 
    this.router.serializeUrl(this.router.createUrlTree(["reports/fill_batch_cyl"], {
      queryParams: {
        fill_Batch_Id: row.fill_Batch_ID,
        reject: true,
      },
    }
  )
  );
  window.open(url,'_blank');
  }

  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (!event.column.prop) {
      return false;
    }

    const sortMapping = {
      fill_Date_Display: "fill_Date_Sorting",
      user: "firstname",
    };

    const sortOrder = event.newValue;
    const sortBy = sortMapping[event.column.prop] || event.column.prop;

    this.page.sortOrder = sortOrder;
    this.page.sortBy = sortBy;

    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.fillBatchReportService
      .getResults(
        this.page,
        this.filter.batch_Num,
        this.filter.start_Date,
        this.filter.end_Date,
        this.filter.quick_Search
      )
      .then((pagedData) => {
        this.page = pagedData.page;
        this.rows = pagedData.data;
        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }

  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable(this.page);
  }

  generateExcel() {
    this.fillBatchReportService
      .getExcel(
        this.filter.batch_Num,
        this.filter.start_Date,
        this.filter.end_Date
      )
      .then((data) => {
        importedSaveAs(data, "Batches.xlsx");
      });
  }

  gotoTop() {
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById("top");
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    console.log("triggered");
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
    this.columnService
      .getColumns(this.client.userId, "fillBatchReport")
      .then((data) => {
        if (data.columns != null) {

          this.selectedOptions = this.availableOptions.filter((c) => {
            return data.columns.includes(c);
          });
        }
      });
  }

  saveSelection() {
    this.columnService
      .save(this.client.userId, "fillBatchReport", this.selectedOptions)
      .then((data) => {});
  }
}
